import { Fragment } from "react";
import { RemoveCircle } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";

import Input from "./Inputs";
import ValueType from "./ValueType";
import TextArea from "./TextArea";
import SingleDropdown from "./DropDown";
import MultiDropdown from "./MultiDropdown";
import TextFieldNumber from "./TextFieldNumber";

export default function Fields({
  fields,
  fieldValue,
  setFieldValue,
  editState,
  state,
  dispatch,
  message,
  formData,
}) {
  return (
    <Fragment>
      {fields.map((field, index) => (
        <Fragment key={field.id}>
          <Grid size={2}>
            <Input
              dispatch={dispatch}
              state={state}
              field={field}
              editState={editState}
            />
          </Grid>

          <Grid size={2}>
            <SingleDropdown
              state={state}
              field={field}
              setFieldValue={setFieldValue}
              fieldValue={fieldValue}
              editState={editState}
              dispatch={dispatch}
            />
          </Grid>

          <Grid size={2}>
            <ValueType
              state={state}
              field={field}
              setFieldValue={setFieldValue}
              fieldValue={fieldValue}
              editState={editState}
              dispatch={dispatch}
            />
          </Grid>

          <Grid size={3}>
            <MultiDropdown
              dispatch={dispatch}
              state={state}
              field={field}
              setFieldValue={setFieldValue}
              fieldValue={fieldValue}
              editState={editState}
            />
          </Grid>

          <TextFieldNumber
            message={message}
            dispatch={dispatch}
            state={state}
            index={index}
            field={field}
            editState={editState}
          />

          {formData.onboardingType === "API" && (
            <Grid size={3}>
              <TextArea
                message={message}
                dispatch={dispatch}
                state={state}
                index={index}
                field={field}
                editState={editState}
              />
            </Grid>
          )}

          {editState && (
            <Grid size={1}>
              <Tooltip title="Clear Values">
                <IconButton
                  onClick={() => {
                    dispatch({
                      type: "CLEAR_VALUES",
                      payload: { name: field.field_name },
                    });
                  }}
                >
                  <RemoveCircle />
                </IconButton>
              </Tooltip>
            </Grid>
          )}

          <Grid size={12} />
        </Fragment>
      ))}
    </Fragment>
  );
}
